import styled from 'styled-components'

export default styled.div`
  background-image: linear-gradient(164deg, #fff0e2 3%, #ffffff 70%);

  .policy-content {
    margin: 40px 0;
  }
`
